<div class="flex flex-row">
    <!-- tickets-->
    <div class="w-full lg:w-2/3 min-h-screen p-4">
        <div class="flex gap-4 flex-wrap w-full flex-row">
            <a routerLink="/dashboard" class="px-3 py-2 text-sm leading-none flex items-center justify-center transition-all ease-in-out duration-200 text-white bg-primary-500 hover:bg-primary-700 focus:bg-primary-700 focus:outline-none"><fa-icon class="mr-2" [icon]="angleLeft"></fa-icon> Zum Dashboard</a>
            <div class="search">
                <label><fa-icon [icon]="search"></fa-icon></label>
                <input type="text" placeholder="Name oder Ticketname" [(ngModel)]="ticketService.filterSearchterm" (ngModelChange)="ticketService.searchtermChanged()">
            </div>
            <div class="checkbox" [ngClass]="{ 'checked': ticketService.showClosedTickets }" (click)="ticketService.toggleCheckbox()">
                <span>Erledigte Tickets anzeigen</span><button><div></div></button>
            </div>
        </div>
        <hr class="my-4">
        <div class="grid gap-4 xxl:grid-cols-3 xl:grid-cols-2 grid-cols-1" *ngIf="ticketService.filteredTickets$ | async; else loading">
            <app-ticket
            class="block"
            *ngFor="let adminTicket of ticketService.filteredTickets$ | async"
            [ticket]="adminTicket"
            [admin]="true"
            ></app-ticket>
        </div>

        <ng-template #loading>
            <div class="w-full flex my-32 justify-center items-center">
                <fa-icon class="text-primary-500 fa-spin" [icon]="circleNotch"></fa-icon>
            </div>
        </ng-template>

    </div>
    <!-- sidebar -->
    <div class="w-full lg:w-1/3 fixed top-0 right-0 h-screen overflow-y-scroll bg-gray-200 hidden lg:block" [ngClass]="{ 'block-important': ticketService.activeTicket }">
        <div *ngIf="!ticketService.activeTicket" class="flex w-full min-h-screen items-center justify-center">
            <span class="text-gray-600 font-medium"><fa-icon [icon]="exclamationTriangle"></fa-icon> Kein Ticket ausgewählt</span>
        </div>
        <div *ngIf="ticketService.activeTicket" class="flex flex-col items-start w-full min-h-screen p-8">
            <button class="block lg:hidden mb-4 text-primary-500 hover:text-primary-700 focus:outline-none focus:text-primary-700" (click)="ticketService.setActiveTicket()">
                <fa-icon [icon]="angleLeft"></fa-icon> Zurück zur Übersicht
            </button>
            <span class="text-xl font-medium">{{ ticketService.activeTicket.name }}<span class="font-normal text-gray-400 text-xs"> - {{ ticketService.activeTicket.tid }}</span></span>
            <!-- state -->
            <div class="status mt-2" [ngClass]="{ open: ticketService.activeTicket.open, closed: !ticketService.activeTicket.open }">
                <div class="state-info">
                    Ticket ist
                </div>
                <div class="state-state">
                    <span *ngIf="ticketService.activeTicket.open">Offen</span>
                    <span *ngIf="!ticketService.activeTicket.open">Erledigt <fa-icon [icon]="check"></fa-icon></span>
                </div>
            </div>
            <!-- user -->
            <span class="mt-4 mb-1 font-medium"><fa-icon class="text-sm" [icon]="user"></fa-icon> Ersteller</span>
            <span>{{ ticketService.activeTicket.creator }}<span class="font-normal text-gray-400 text-xs"> - {{ ticketService.activeTicket.uid }}</span></span>
            <!-- address -->
            <span class="mt-4 mb-1 font-medium"><fa-icon class="text-sm" [icon]="mapMarker"></fa-icon> Adresse</span>
            <span>{{ ticketService.activeTicket.address }}</span>
            <!-- category -->
            <span class="mt-4 mb-1 font-medium"><fa-icon class="text-sm" [icon]="layerGroup"></fa-icon> Kategorie</span>
            <span>{{ ticketService.activeTicket.category }}</span>
            <!-- desc -->
            <span class="mt-4 mb-1 font-medium"><fa-icon class="text-sm" [icon]="infoCircle"></fa-icon> Beschreibung</span>
            <span>{{ ticketService.activeTicket.description }}</span>
            <!-- images -->
            <span class="mt-4 mb-2 font-medium"><fa-icon class="text-sm" [icon]="rectangleLandscape"></fa-icon> Bilder</span>
            <div *ngIf="ticketService.activeTicket.images.length < 1">
                Keine Bilder hinzugefügt
            </div>
            <div *ngIf="ticketService.activeTicket.images.length > 0" class="grid gird-cols-2 gap-4 w-full">
                <a href={{image.url}} target="_blank" *ngFor="let image of ticketService.activeTicket.images">
                    <img src={{image.url}} class="rounded w-auto" style="max-height: 400px;">
                </a>
            </div>
            <hr class="my-8 w-full border-gray-400">
            <div class="w-full flex items-center justify-center">
                <!-- close ticket button -->
                <button
                *ngIf="ticketService.activeTicket.open"
                class="text-center text-white px-2 py-1 bg-primary-500 text-sm focus:outline-none hover:bg-primary-700 focus:bg-primary-700"
                (click)="ticketService.closeTicket(ticketService.activeTicket.tid)"
                >
                    Ticket schließen <fa-icon [icon]="check"></fa-icon>
                </button>
                <!-- reopen ticket button -->
                <button
                    *ngIf="!ticketService.activeTicket.open"
                    class="text-center text-white px-2 py-1 bg-primary-500 text-sm focus:outline-none hover:bg-primary-700 focus:bg-primary-700"
                    (click)="ticketService.reopenTicket(ticketService.activeTicket.tid)"
                >
                    Ticket erneut öffnen <fa-icon [icon]="ban"></fa-icon>
                </button>
            </div>
        </div>
    </div>
</div>